import { React, useState, useEffect } from "react";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import ProductThumbNailGroup from "../ProductThumbNailGroup/ProductThumbNailGroup";
import AddToCartB from "../AddToCart/AddToCartB";
import BestGear from "../BestGear/BestGear";
import AlsoLike from "../AlsoLike/AlsoLike";
import markOne from "../../assets/product-xx99-mark-one-headphones/desktop/image-product.jpg";
import markOneTab from "../../assets/product-xx99-mark-one-headphones/tablet/image-product.jpg";
import markOneMobile from "../../assets/product-xx99-mark-one-headphones/mobile/image-product.jpg";
import Footer from "../Footer/Footer";
import Features from "../Features/Features";
import marktwo from "../../assets/shared/desktop/image-xx99-mark-two-headphones.jpg";
import marktwoTab from "../../assets/shared/tablet/image-xx99-mark-two-headphones.jpg";
import marktwoMobile from "../../assets/shared/mobile/image-xx99-mark-two-headphones.jpg";
import speaker from "../../assets/shared/desktop/image-zx9-speaker.jpg";
import speakerTab from "../../assets/shared/tablet/image-zx9-speaker.jpg";
import speakerMobile from "../../assets/shared/mobile/image-zx9-speaker.jpg";
import xx59 from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import xx59Tab from "../../assets/shared/tablet/image-xx59-headphones.jpg";
import xx59Mobile from "../../assets/shared/mobile/image-xx59-headphones.jpg";
import ProductGallery from "../ProductGallery/ProductGallery";
import imgGallery1 from "../../assets/product-xx99-mark-one-headphones/desktop/image-gallery-1.jpg";
import imgGallery2 from "../../assets/product-xx99-mark-one-headphones/desktop/image-gallery-2.jpg";
import imgGallery3 from "../../assets/product-xx99-mark-one-headphones/desktop/image-gallery-3.jpg";

const HeadphonesMarkOne = ({
  addMarkOneToCart,
  cart,
  updateMyCart,
  id,
  updateQuantity,
  increment,
  decrement,
  quantity,
  markOneIncrement,
  markOneDecrement,
  markOneQuantity,
}) => {
  const [imgUrl, setImgURL] = useState("");
  const [marktwoURL, setMarktwoURL] = useState("");
  const [speakerURL, setSpeakerURL] = useState("");
  const [xx59URL, setxx59URL] = useState("");
  useEffect(() => {
    const handleResize = () => {
      console.log("Resizing...");
      if (window.innerWidth <= 450) {
        console.log("Resizing for HeadphonesMarkOne.jsx mobile view");
        setImgURL(markOneMobile);
        setMarktwoURL(marktwoMobile);
        setSpeakerURL(speakerMobile);
        setxx59URL(xx59Mobile);
      } else if (window.innerWidth <= 768) {
        console.log("Resizing for HeadphonesMarkOne.jsx tablet view");
        setImgURL(markOneTab);
        setMarktwoURL(marktwoTab);
        setSpeakerURL(speakerTab);
        setxx59URL(xx59Tab);
      } else {
        console.log("Resizing for HeadphonesMarkOne.jsx desktop view");
        setImgURL(markOne);
        setMarktwoURL(marktwo);
        setSpeakerURL(speaker);
        setxx59URL(xx59);
      }

      console.log("Resize in Progress");
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // // Define increment and decrement functions
  // const increment = (productId) => {
  //   // Logic to increment quantity of product with productId
  // };

  // const decrement = (productId) => {
  //   // Logic to decrement quantity of product with productId
  // };

  return (
    <>
      <HeaderB
        cart={cart}
        updateCartQuantity={updateQuantity}
        // increment={increment}
        // decrement={decrement}
        // quantity={quantity}
        markOneIncrement={increment}
        markOneDecrement={decrement}
        markOneQuantity={quantity}
      />
      <main>
        <GoBackLink />
        <AddToCartB
          imageURL={imgUrl}
          productName={
            <>
              XX99 Mark I <br /> Headphones
            </>
          }
          description="As the gold standard for headphones, the classic XX99 Mark I offers detailed and accurate 
  audio reproduction for audiophiles, mixing engineers, and music aficionados alike in studios 
  and on the go."
          price="1750"
          addItem={updateMyCart}
          key={id}
          updateQuantity={updateQuantity}
          quantity={quantity}
          increment={increment}
          decrement={decrement}
        />
        <Features
          p1="As the headphones all others are measured against, the XX99 Mark I demonstrates over five decades 
  of audio expertise, redefining the critical listening experience. This pair of closed-back headphones 
  are made of industrial, aerospace-grade materials to emphasize durability at a relatively light weight of 11 oz."
          p2="From the handcrafted microfiber ear cushions to the robust metal headband with inner damping element, 
          the components work together to deliver comfort and uncompromising sound. Its closed-back design delivers 
          up to 27 dB of passive noise cancellation, reducing resonance by reflecting sound to a dedicated absorber. 
          For connectivity, a specially tuned cable is included with a balanced gold connector.  "
        />
        <ProductGallery image={[imgGallery1, imgGallery2, imgGallery3]} />
        <AlsoLike
          image={[marktwoURL, xx59URL, speakerURL]}
          title={["XX99 MARK II", "XX59", "ZX9 SPEAKER"]}
          nav1={"/headphones/markTwo"}
          nav2={"/headphones/xx59"}
          nav3={"/speakerZx9"}
        />
        <ProductThumbNailGroup />
        <BestGear />
        <Footer />
      </main>
    </>
  );
};

export default HeadphonesMarkOne;
